import { render, staticRenderFns } from "./KpiWidget.vue?vue&type=template&id=83dcdce6&"
import script from "./KpiWidget.vue?vue&type=script&lang=js&"
export * from "./KpiWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports